var items = {
  "block.minecraft.air": "aire",
  "block.minecraft.stone": "piedra",
  "block.minecraft.granite": "granitu",
  "block.minecraft.polished_granite": "granitu pulío",
  "block.minecraft.diorite": "diorita",
  "block.minecraft.polished_diorite": "diorita pulío",
  "block.minecraft.andesite": "andesita",
  "block.minecraft.polished_andesite": "andesita pulío",
  "block.minecraft.grass_block": "tapín",
  "block.minecraft.dirt": "tierra",
  "block.minecraft.coarse_dirt": "tierra seco",
  "block.minecraft.podzol": "llamargu",
  "block.minecraft.crimson_nylium": "niliu carmesín",
  "block.minecraft.warped_nylium": "niliu distorsionao",
  "block.minecraft.cobblestone": "llastra",
  "block.minecraft.oak_planks": "tables de carbayu",
  "block.minecraft.spruce_planks": "tables d'abetu",
  "block.minecraft.birch_planks": "tables de bidul",
  "block.minecraft.jungle_planks": "tables de madera de la xungla",
  "block.minecraft.acacia_planks": "tables d'alcacia",
  "block.minecraft.dark_oak_planks": "tables de carbayu escuru",
  "block.minecraft.crimson_planks": "tables carmesín",
  "block.minecraft.warped_planks": "tables distorsionaes",
  "block.minecraft.oak_sapling": "biltu de carbayu",
  "block.minecraft.spruce_sapling": "biltu d'abetu",
  "block.minecraft.birch_sapling": "biltu de bidul",
  "block.minecraft.jungle_sapling": "biltu de la xungla",
  "block.minecraft.acacia_sapling": "biltu d'alcacia",
  "block.minecraft.dark_oak_sapling": "biltu de carbayu escuru",
  "block.minecraft.bedrock": "piedra base",
  "block.minecraft.sand": "sable",
  "block.minecraft.red_sand": "sable colorao",
  "block.minecraft.gravel": "grava",
  "block.minecraft.gold_ore": "veta d'oru",
  "block.minecraft.iron_ore": "veta de fierro",
  "block.minecraft.coal_ore": "veta de carbón",
  "block.minecraft.nether_gold_ore": "veta d'oru del nether",
  "block.minecraft.oak_log": "tueru de carbayu",
  "block.minecraft.spruce_log": "tueru d'abetu",
  "block.minecraft.birch_log": "tueru de bidul",
  "block.minecraft.jungle_log": "tueru de madera de la xungla",
  "block.minecraft.acacia_log": "tueru d'alcacia",
  "block.minecraft.dark_oak_log": "tueru de carbayu escuru",
  "block.minecraft.crimson_stem": "madera carmesín",
  "block.minecraft.warped_stem": "madera distorsionao",
  "block.minecraft.stripped_oak_log": "tueru de carbayu ensin corteza",
  "block.minecraft.stripped_spruce_log": "tueru d'abetu ensin corteza",
  "block.minecraft.stripped_birch_log": "tueru de bidul ensin corteza",
  "block.minecraft.stripped_jungle_log": "tueru de madera ensin corteza de la xungla",
  "block.minecraft.stripped_acacia_log": "tueru d'alcacia ensin corteza",
  "block.minecraft.stripped_dark_oak_log": "tueru de carbayu escuru ensin corteza",
  "block.minecraft.stripped_crimson_stem": "tueru carmesín ensin corteza",
  "block.minecraft.stripped_warped_stem": "tueru distorsionáu ensin corteza",
  "block.minecraft.stripped_oak_wood": "madera de carbayu ensin corteza",
  "block.minecraft.stripped_spruce_wood": "madera d'abetu ensin corteza",
  "block.minecraft.stripped_birch_wood": "madera de bidul ensin corteza",
  "block.minecraft.stripped_jungle_wood": "madera ensin corteza de la xungla",
  "block.minecraft.stripped_acacia_wood": "madera d'alcacia ensin corteza",
  "block.minecraft.stripped_dark_oak_wood": "madera de carbayu escuru ensin corteza",
  "block.minecraft.stripped_crimson_hyphae": "stripped crimson hyphae",
  "block.minecraft.stripped_warped_hyphae": "stripped warped hyphae",
  "block.minecraft.oak_wood": "madera de carbayu con corteza",
  "block.minecraft.spruce_wood": "madera d'abetu con corteza",
  "block.minecraft.birch_wood": "madera de bidul con corteza",
  "block.minecraft.jungle_wood": "madera de la xungla con corteza",
  "block.minecraft.acacia_wood": "madera d'alcacia con corteza",
  "block.minecraft.dark_oak_wood": "madera de carbayu escuru con corteza",
  "block.minecraft.crimson_hyphae": "crimson hyphae",
  "block.minecraft.warped_hyphae": "warped hyphae",
  "block.minecraft.oak_leaves": "fueyes de carbayu",
  "block.minecraft.spruce_leaves": "fueyes d'abetu",
  "block.minecraft.birch_leaves": "fueyes de bidul",
  "block.minecraft.jungle_leaves": "fueyes de la xungla",
  "block.minecraft.acacia_leaves": "fueyes d'alcacia",
  "block.minecraft.dark_oak_leaves": "fueyes de carbayu escuru",
  "block.minecraft.sponge": "esponxa",
  "block.minecraft.wet_sponge": "esponxa moyada",
  "block.minecraft.glass": "vidru",
  "block.minecraft.lapis_ore": "veta de llapislázuli",
  "block.minecraft.lapis_block": "bloque de llapislázuli",
  "block.minecraft.dispenser": "llanzador",
  "block.minecraft.sandstone": "gres",
  "block.minecraft.chiseled_sandstone": "gres cincelao",
  "block.minecraft.cut_sandstone": "gres cortao",
  "block.minecraft.note_block": "bloque de notes",
  "block.minecraft.powered_rail": "vía puxadora",
  "block.minecraft.detector_rail": "vía detectora",
  "block.minecraft.sticky_piston": "pistón pegañón",
  "block.minecraft.cobweb": "telaraña",
  "block.minecraft.grass": "yerba",
  "block.minecraft.fern": "felechu",
  "block.minecraft.dead_bush": "plantu muertu",
  "block.minecraft.seagrass": "ocle marino",
  "block.minecraft.sea_pickle": "pirosoma",
  "block.minecraft.piston": "pistón",
  "block.minecraft.white_wool": "llana blanco",
  "block.minecraft.orange_wool": "llana naranxa",
  "block.minecraft.magenta_wool": "llana maxenta",
  "block.minecraft.light_blue_wool": "llana azul claro",
  "block.minecraft.yellow_wool": "llana mariello",
  "block.minecraft.lime_wool": "llana llima",
  "block.minecraft.pink_wool": "llana rosa",
  "block.minecraft.gray_wool": "llana buxo",
  "block.minecraft.light_gray_wool": "llana buxo claro",
  "block.minecraft.cyan_wool": "llana ciano",
  "block.minecraft.purple_wool": "llana morao",
  "block.minecraft.blue_wool": "llana azul",
  "block.minecraft.brown_wool": "llana marrón",
  "block.minecraft.green_wool": "llana verde",
  "block.minecraft.red_wool": "llana colorao",
  "block.minecraft.black_wool": "llana prieto",
  "block.minecraft.dandelion": "xiblata",
  "block.minecraft.poppy": "papola",
  "block.minecraft.blue_orchid": "orquídea azul",
  "block.minecraft.allium": "ayu bravu",
  "block.minecraft.azure_bluet": "houstonia caerulea",
  "block.minecraft.red_tulip": "tulipán coloráu",
  "block.minecraft.orange_tulip": "tulipán naranxa",
  "block.minecraft.white_tulip": "tulipán blancu",
  "block.minecraft.pink_tulip": "tulipán rosa",
  "block.minecraft.oxeye_daisy": "catasol grande",
  "block.minecraft.cornflower": "clavelina",
  "block.minecraft.lily_of_the_valley": "lliriu de los valles",
  "block.minecraft.wither_rose": "rosa de wither",
  "block.minecraft.brown_mushroom": "xampiñón",
  "block.minecraft.red_mushroom": "xetu roxu",
  "block.minecraft.crimson_fungus": "fungu carmesín",
  "block.minecraft.warped_fungus": "fungu distorsionáu",
  "block.minecraft.crimson_roots": "yerba carmesín",
  "block.minecraft.warped_roots": "yerba distorsionao",
  "block.minecraft.nether_sprouts": "nether sprouts",
  "block.minecraft.weeping_vines": "weeping vines",
  "block.minecraft.twisting_vines": "twisting vines",
  "block.minecraft.sugar_cane": "caña d'azucre",
  "block.minecraft.kelp": "laminarial",
  "block.minecraft.bamboo": "bambú",
  "block.minecraft.gold_block": "bloque d'oru",
  "block.minecraft.iron_block": "bloque de fierro",
  "block.minecraft.oak_slab": "llábana de carbayu",
  "block.minecraft.spruce_slab": "llábana d'abetu",
  "block.minecraft.birch_slab": "llábana de bidul",
  "block.minecraft.jungle_slab": "llábana de madera de la xungla",
  "block.minecraft.acacia_slab": "llábana d'alcacia",
  "block.minecraft.dark_oak_slab": "llábana de carbayu escuru",
  "block.minecraft.crimson_slab": "llábana carmesín",
  "block.minecraft.warped_slab": "llábana distorsionada",
  "block.minecraft.stone_slab": "llábana de piedra",
  "block.minecraft.smooth_stone_slab": "llábana de piedra donda",
  "block.minecraft.sandstone_slab": "llábana de gres",
  "block.minecraft.cut_sandstone_slab": "llábana de gres cortada",
  "block.minecraft.petrified_oak_slab": "llábana de carbayu petrificáu",
  "block.minecraft.cobblestone_slab": "llábana de llastra",
  "block.minecraft.brick_slab": "llábana de lladriyos",
  "block.minecraft.stone_brick_slab": "llábana de lladriyos de piedra",
  "block.minecraft.nether_brick_slab": "llábana de lladriyos del nether",
  "block.minecraft.quartz_slab": "llábana de cuarzu",
  "block.minecraft.red_sandstone_slab": "llábana de gres colorao",
  "block.minecraft.cut_red_sandstone_slab": "llábana de gres colorao cortada",
  "block.minecraft.purpur_slab": "llábana de purpur",
  "block.minecraft.prismarine_slab": "llábana de prismarín",
  "block.minecraft.prismarine_brick_slab": "llábana de lladriyos de prismarín",
  "block.minecraft.dark_prismarine_slab": "llábana de prismarín escuro",
  "block.minecraft.smooth_quartz": "bloque de cuarzu dondo",
  "block.minecraft.smooth_red_sandstone": "gres colorao dondo",
  "block.minecraft.smooth_sandstone": "gres dondo",
  "block.minecraft.smooth_stone": "piedra donda",
  "block.minecraft.bricks": "lladriyos",
  "block.minecraft.tnt": "tnt",
  "block.minecraft.bookshelf": "llibrería",
  "block.minecraft.mossy_cobblestone": "llastra mofoso",
  "block.minecraft.obsidian": "obsidiana",
  "block.minecraft.torch": "antorcha",
  "block.minecraft.end_rod": "vara del end",
  "block.minecraft.chorus_plant": "planta del coru",
  "block.minecraft.chorus_flower": "flor del coru",
  "block.minecraft.purpur_block": "bloque de purpur",
  "block.minecraft.purpur_pillar": "pilar de purpur",
  "block.minecraft.purpur_stairs": "pasales de purpur",
  "block.minecraft.spawner": "aprucidor",
  "block.minecraft.oak_stairs": "pasales de carbayu",
  "block.minecraft.chest": "bagul",
  "block.minecraft.diamond_ore": "veta de diamante",
  "block.minecraft.diamond_block": "bloque de diamante",
  "block.minecraft.crafting_table": "mesa d'ellaboración",
  "block.minecraft.farmland": "eru",
  "block.minecraft.furnace": "fornu",
  "block.minecraft.ladder": "escalera de mano",
  "block.minecraft.rail": "vía",
  "block.minecraft.cobblestone_stairs": "pasales de llastra",
  "block.minecraft.lever": "palanca",
  "block.minecraft.stone_pressure_plate": "placa presión de piedra",
  "block.minecraft.oak_pressure_plate": "placa de presión de carbayu",
  "block.minecraft.spruce_pressure_plate": "placa de presión d'abetu",
  "block.minecraft.birch_pressure_plate": "placa de presión de bidul",
  "block.minecraft.jungle_pressure_plate": "placa de presión de madera de la xungla",
  "block.minecraft.acacia_pressure_plate": "placa de presión d'alcacia",
  "block.minecraft.dark_oak_pressure_plate": "placa de presión de carbayu escuru",
  "block.minecraft.crimson_pressure_plate": "placa de presión carmesín",
  "block.minecraft.warped_pressure_plate": "placa distorsionada de presión",
  "block.minecraft.polished_blackstone_pressure_plate": "placa de presión de nigrilitu pulío",
  "block.minecraft.redstone_ore": "veta de redstone",
  "block.minecraft.redstone_torch": "antorcha de redstone",
  "block.minecraft.snow": "ñeve",
  "block.minecraft.ice": "xelu",
  "block.minecraft.snow_block": "bloque de ñeve",
  "block.minecraft.cactus": "cactus",
  "block.minecraft.clay": "barru santo",
  "block.minecraft.jukebox": "tocadiscos",
  "block.minecraft.oak_fence": "valla de carbayu",
  "block.minecraft.spruce_fence": "valla d'abetu",
  "block.minecraft.birch_fence": "valla de bidul",
  "block.minecraft.jungle_fence": "valla de madera de la xungla",
  "block.minecraft.acacia_fence": "valla d'alcacia",
  "block.minecraft.dark_oak_fence": "valla de carbayu escuru",
  "block.minecraft.crimson_fence": "valla carmesina",
  "block.minecraft.warped_fence": "valla distorsionada",
  "block.minecraft.pumpkin": "calabaza",
  "block.minecraft.carved_pumpkin": "calabaza tallada",
  "block.minecraft.netherrack": "netherrack",
  "block.minecraft.soul_sand": "sable d'ánimes",
  "block.minecraft.soul_soil": "tierra d'ánimes",
  "block.minecraft.basalt": "basaltu",
  "block.minecraft.polished_basalt": "basaltu pulío",
  "block.minecraft.soul_torch": "antorcha d'ánimes",
  "block.minecraft.glowstone": "piedra rellumante",
  "block.minecraft.jack_o_lantern": "jack o'lantern",
  "block.minecraft.oak_trapdoor": "trapiella de carbayu",
  "block.minecraft.spruce_trapdoor": "trapiella d'abetu",
  "block.minecraft.birch_trapdoor": "carbayu de bidul",
  "block.minecraft.jungle_trapdoor": "trapiella de madera de la xungla",
  "block.minecraft.acacia_trapdoor": "trapiella d'alcacia",
  "block.minecraft.dark_oak_trapdoor": "trapiella de carbayu escuru",
  "block.minecraft.crimson_trapdoor": "trapiella carmesín",
  "block.minecraft.warped_trapdoor": "trapiella distorsionada",
  "block.minecraft.infested_stone": "piedra infestada",
  "block.minecraft.infested_cobblestone": "llastra infestao",
  "block.minecraft.infested_stone_bricks": "lladriyos de piedra infestada",
  "block.minecraft.infested_mossy_stone_bricks": "lladriyos de piedra mofosa infestada",
  "block.minecraft.infested_cracked_stone_bricks": "lladriyos de piedra frañida infestada",
  "block.minecraft.infested_chiseled_stone_bricks": "lladriyos de piedra cincelada infestada",
  "block.minecraft.stone_bricks": "lladriyos de piedra",
  "block.minecraft.mossy_stone_bricks": "lladriyos de piedra mofosa",
  "block.minecraft.cracked_stone_bricks": "lladriyos de piedra frañida",
  "block.minecraft.chiseled_stone_bricks": "lladriyos de piedra cincelada",
  "block.minecraft.brown_mushroom_block": "bloque de fungos marrones",
  "block.minecraft.red_mushroom_block": "bloque de xetos roxos",
  "block.minecraft.mushroom_stem": "tallu de fungu",
  "block.minecraft.iron_bars": "barrotes de fierro",
  "block.minecraft.chain": "cadena",
  "block.minecraft.glass_pane": "panel de vidru",
  "block.minecraft.melon": "sandía",
  "block.minecraft.vine": "enromadoriu",
  "block.minecraft.oak_fence_gate": "portiella de carbayu",
  "block.minecraft.spruce_fence_gate": "portiella d'abetu",
  "block.minecraft.birch_fence_gate": "portiella de bidul",
  "block.minecraft.jungle_fence_gate": "portiella de madera de la xungla",
  "block.minecraft.acacia_fence_gate": "portiella d'alcacia",
  "block.minecraft.dark_oak_fence_gate": "portiella de carbayu escuru",
  "block.minecraft.crimson_fence_gate": "portiella carmesín",
  "block.minecraft.warped_fence_gate": "portiella distorsionada",
  "block.minecraft.brick_stairs": "pasales de lladriyu",
  "block.minecraft.stone_brick_stairs": "pasales de lladriyos de piedra",
  "block.minecraft.mycelium": "miceliu",
  "block.minecraft.lily_pad": "nenúfar",
  "block.minecraft.nether_bricks": "lladriyos del nether",
  "block.minecraft.cracked_nether_bricks": "lladriyos del nether frañaos",
  "block.minecraft.chiseled_nether_bricks": "lladriyos del nether cincelaos",
  "block.minecraft.nether_brick_fence": "valla de lladriyos del nether",
  "block.minecraft.nether_brick_stairs": "pasales de lladriyos del nether",
  "block.minecraft.enchanting_table": "mesa d'encantexos",
  "block.minecraft.end_portal_frame": "marcu d'un portal al end",
  "block.minecraft.end_stone": "piedra del end",
  "block.minecraft.end_stone_bricks": "lladriyos de piedra del end",
  "block.minecraft.dragon_egg": "güevu de cuélebre",
  "block.minecraft.redstone_lamp": "llámpara de redstone",
  "block.minecraft.sandstone_stairs": "pasales de gres",
  "block.minecraft.emerald_ore": "veta d'esmeralda",
  "block.minecraft.ender_chest": "bagul d'ender",
  "block.minecraft.tripwire_hook": "ganchu",
  "block.minecraft.emerald_block": "bloque d'esmeralda",
  "block.minecraft.spruce_stairs": "pasales d'abetu",
  "block.minecraft.birch_stairs": "pasales de bidul",
  "block.minecraft.jungle_stairs": "pasales de madera de la xungla",
  "block.minecraft.crimson_stairs": "pasales carmesín",
  "block.minecraft.warped_stairs": "pasales distorsionaos",
  "block.minecraft.command_block": "bloque de comandos",
  "block.minecraft.beacon": "baliza",
  "block.minecraft.cobblestone_wall": "muria de llastra",
  "block.minecraft.mossy_cobblestone_wall": "muria de llastra mofoso",
  "block.minecraft.brick_wall": "muria de lladriyos",
  "block.minecraft.prismarine_wall": "muria de prismarín",
  "block.minecraft.red_sandstone_wall": "muria de gres colorao",
  "block.minecraft.mossy_stone_brick_wall": "muria de lladriyos de piedra mofosa",
  "block.minecraft.granite_wall": "muria de granitu",
  "block.minecraft.stone_brick_wall": "muria de lladriyos de piedra",
  "block.minecraft.nether_brick_wall": "muria de lladriyos del nether",
  "block.minecraft.andesite_wall": "muria d'andesita",
  "block.minecraft.red_nether_brick_wall": "muria de lladriyos coloraos del nether",
  "block.minecraft.sandstone_wall": "muria de gres",
  "block.minecraft.end_stone_brick_wall": "muria de lladriyos de piedra del end",
  "block.minecraft.diorite_wall": "muria de diorita",
  "block.minecraft.blackstone_wall": "muria de nigrilitu",
  "block.minecraft.polished_blackstone_wall": "muria de nigrilitu pulío",
  "block.minecraft.polished_blackstone_brick_wall": "muria de lladriyos de nigrilitu pulío",
  "block.minecraft.stone_button": "botón de piedra",
  "block.minecraft.oak_button": "botón de carbayu",
  "block.minecraft.spruce_button": "botón d'abetu",
  "block.minecraft.birch_button": "botón de bidul",
  "block.minecraft.jungle_button": "botón de madera de la xungla",
  "block.minecraft.acacia_button": "botón d'alcacia",
  "block.minecraft.dark_oak_button": "botón de carbayu escuru",
  "block.minecraft.crimson_button": "botón carmesín",
  "block.minecraft.warped_button": "botón distorsionáu",
  "block.minecraft.polished_blackstone_button": "botón de nigrilitu pulío",
  "block.minecraft.anvil": "xuncla",
  "block.minecraft.chipped_anvil": "xuncla estellada",
  "block.minecraft.damaged_anvil": "xuncla perdañada",
  "block.minecraft.trapped_chest": "bagul trampa",
  "block.minecraft.light_weighted_pressure_plate": "placa de presión pa pesu llixeru",
  "block.minecraft.heavy_weighted_pressure_plate": "placa de presión pa pesu pesáu",
  "block.minecraft.daylight_detector": "sensor de llume solar",
  "block.minecraft.redstone_block": "bloque de redstone",
  "block.minecraft.nether_quartz_ore": "veta de cuarzu del nether",
  "block.minecraft.hopper": "embudu",
  "block.minecraft.chiseled_quartz_block": "bloque de cuarzu cincelao",
  "block.minecraft.quartz_block": "bloque de cuarzu",
  "block.minecraft.quartz_bricks": "lladriyos de cuarzu",
  "block.minecraft.quartz_pillar": "pilar de cuarzu",
  "block.minecraft.quartz_stairs": "pasales de cuarzu",
  "block.minecraft.activator_rail": "vía activadora",
  "block.minecraft.dropper": "apurridor",
  "block.minecraft.white_terracotta": "terracota blanco",
  "block.minecraft.orange_terracotta": "terracota naranxa",
  "block.minecraft.magenta_terracotta": "terracota maxenta",
  "block.minecraft.light_blue_terracotta": "terracota azul claro",
  "block.minecraft.yellow_terracotta": "terracota mariello",
  "block.minecraft.lime_terracotta": "terracota llima",
  "block.minecraft.pink_terracotta": "terracota rosa",
  "block.minecraft.gray_terracotta": "terracota buxo",
  "block.minecraft.light_gray_terracotta": "terracota buxo claro",
  "block.minecraft.cyan_terracotta": "terracota ciano",
  "block.minecraft.purple_terracotta": "terracota morao",
  "block.minecraft.blue_terracotta": "terracota azul",
  "block.minecraft.brown_terracotta": "terracota marrón",
  "block.minecraft.green_terracotta": "terracota verde",
  "block.minecraft.red_terracotta": "terracota colorao",
  "block.minecraft.black_terracotta": "terracota prieto",
  "block.minecraft.barrier": "barrera",
  "block.minecraft.iron_trapdoor": "trapiella de fierro",
  "block.minecraft.hay_block": "paca",
  "block.minecraft.white_carpet": "moqueta blanca",
  "block.minecraft.orange_carpet": "moqueta naranxa",
  "block.minecraft.magenta_carpet": "moqueta maxenta",
  "block.minecraft.light_blue_carpet": "moqueta azul claro",
  "block.minecraft.yellow_carpet": "moqueta mariella",
  "block.minecraft.lime_carpet": "moqueta llima",
  "block.minecraft.pink_carpet": "moqueta rosa",
  "block.minecraft.gray_carpet": "moqueta buxa",
  "block.minecraft.light_gray_carpet": "moqueta buxa clara",
  "block.minecraft.cyan_carpet": "moqueta ciana",
  "block.minecraft.purple_carpet": "moqueta morada",
  "block.minecraft.blue_carpet": "moqueta azul",
  "block.minecraft.brown_carpet": "moqueta marrón",
  "block.minecraft.green_carpet": "moqueta verde",
  "block.minecraft.red_carpet": "moqueta colorada",
  "block.minecraft.black_carpet": "moqueta prieta",
  "block.minecraft.terracotta": "terracota",
  "block.minecraft.coal_block": "bloque de carbón",
  "block.minecraft.packed_ice": "xelu compauto",
  "block.minecraft.acacia_stairs": "pasales d'alcacia",
  "block.minecraft.dark_oak_stairs": "pasales de carbayu escuru",
  "block.minecraft.slime_block": "bloque de llimu",
  "block.minecraft.grass_path": "sienda",
  "block.minecraft.sunflower": "xirasol",
  "block.minecraft.lilac": "lilá",
  "block.minecraft.rose_bush": "rosal",
  "block.minecraft.peony": "peonia",
  "block.minecraft.tall_grass": "yerba alto",
  "block.minecraft.large_fern": "felechu grande",
  "block.minecraft.white_stained_glass": "vidru tintao en blanco",
  "block.minecraft.orange_stained_glass": "vidru tintao en naranxa",
  "block.minecraft.magenta_stained_glass": "vidru tintao en maxenta",
  "block.minecraft.light_blue_stained_glass": "vidru tintao n'azul claro",
  "block.minecraft.yellow_stained_glass": "vidru tintao en mariello",
  "block.minecraft.lime_stained_glass": "vidru tintao en llima",
  "block.minecraft.pink_stained_glass": "vidru tintao en rosa",
  "block.minecraft.gray_stained_glass": "vidru tintao en buxo",
  "block.minecraft.light_gray_stained_glass": "vidru tintao en buxo claro",
  "block.minecraft.cyan_stained_glass": "vidru tintao en ciano",
  "block.minecraft.purple_stained_glass": "vidru tintao en morao",
  "block.minecraft.blue_stained_glass": "vidru tintao n'azul",
  "block.minecraft.brown_stained_glass": "vidru tintao en marrón",
  "block.minecraft.green_stained_glass": "vidru tintao en verde",
  "block.minecraft.red_stained_glass": "vidru tintao en colorao",
  "block.minecraft.black_stained_glass": "vidru tintao en prieto",
  "block.minecraft.white_stained_glass_pane": "panel de vidru tintao en blanco",
  "block.minecraft.orange_stained_glass_pane": "panel de vidru tintao en naranxa",
  "block.minecraft.magenta_stained_glass_pane": "panel de vidru tintao en maxenta",
  "block.minecraft.light_blue_stained_glass_pane": "panel de vidru tintao n'azul claro",
  "block.minecraft.yellow_stained_glass_pane": "panel de vidru tintao en mariello",
  "block.minecraft.lime_stained_glass_pane": "panel de vidru tintao en llima",
  "block.minecraft.pink_stained_glass_pane": "panel de vidru tintao en rosa",
  "block.minecraft.gray_stained_glass_pane": "panel de vidru tintao en buxo",
  "block.minecraft.light_gray_stained_glass_pane": "panel de vidru tintao en buxo claro",
  "block.minecraft.cyan_stained_glass_pane": "panel de vidru tintao en ciano",
  "block.minecraft.purple_stained_glass_pane": "panel de vidru tintao en morao",
  "block.minecraft.blue_stained_glass_pane": "panel de vidru tintao n'azul",
  "block.minecraft.brown_stained_glass_pane": "panel de vidru tintao en marrón",
  "block.minecraft.green_stained_glass_pane": "panel de vidru tintao en verde",
  "block.minecraft.red_stained_glass_pane": "panel de vidru tintao en colorao",
  "block.minecraft.black_stained_glass_pane": "panel de vidru tintao en prieto",
  "block.minecraft.prismarine": "prismarín",
  "block.minecraft.prismarine_bricks": "lladriyos de prismarín",
  "block.minecraft.dark_prismarine": "prismarín escuro",
  "block.minecraft.prismarine_stairs": "pasales de prismarín",
  "block.minecraft.prismarine_brick_stairs": "pasales de lladriyos de prismarín",
  "block.minecraft.dark_prismarine_stairs": "pasales de prismarín escuro",
  "block.minecraft.sea_lantern": "llámpara marina",
  "block.minecraft.red_sandstone": "gres colorao",
  "block.minecraft.chiseled_red_sandstone": "gres colorao cincelao",
  "block.minecraft.cut_red_sandstone": "gres colorao cortao",
  "block.minecraft.red_sandstone_stairs": "pasales de gres colorao",
  "block.minecraft.repeating_command_block": "bloque de comandos iterativu",
  "block.minecraft.chain_command_block": "bloque de comandos en cadena",
  "block.minecraft.magma_block": "bloque magmáticu",
  "block.minecraft.nether_wart_block": "bloque d'úzara del nether",
  "block.minecraft.warped_wart_block": "bloque d'úzares distorsionaes",
  "block.minecraft.red_nether_bricks": "lladriyos del nether coloraos",
  "block.minecraft.bone_block": "bloque oseu",
  "block.minecraft.structure_void": "vacíu de cadarma",
  "block.minecraft.observer": "observador",
  "block.minecraft.shulker_box": "caxa de shulker",
  "block.minecraft.white_shulker_box": "caxa blanca de shulker",
  "block.minecraft.orange_shulker_box": "caxa naranxa de shulker",
  "block.minecraft.magenta_shulker_box": "caxa maxenta de shulker",
  "block.minecraft.light_blue_shulker_box": "caxa azul claro de shulker",
  "block.minecraft.yellow_shulker_box": "caxa mariella de shulker",
  "block.minecraft.lime_shulker_box": "caxa llima de shulker",
  "block.minecraft.pink_shulker_box": "caxa rosa de shulker",
  "block.minecraft.gray_shulker_box": "caxa buxa de shulker",
  "block.minecraft.light_gray_shulker_box": "caxa buxa claro de shulker",
  "block.minecraft.cyan_shulker_box": "caxa ciana de shulker",
  "block.minecraft.purple_shulker_box": "caxa morada de shulker",
  "block.minecraft.blue_shulker_box": "caxa azul de shulker",
  "block.minecraft.brown_shulker_box": "caxa marrón de shulker",
  "block.minecraft.green_shulker_box": "caxa verde de shulker",
  "block.minecraft.red_shulker_box": "caxa colorada de shulker",
  "block.minecraft.black_shulker_box": "caxa prieta de shulker",
  "block.minecraft.white_glazed_terracotta": "azulexu blancu",
  "block.minecraft.orange_glazed_terracotta": "azulexu naranxa",
  "block.minecraft.magenta_glazed_terracotta": "azulexu maxenta",
  "block.minecraft.light_blue_glazed_terracotta": "azulexu azul claro",
  "block.minecraft.yellow_glazed_terracotta": "azulexu mariellu",
  "block.minecraft.lime_glazed_terracotta": "azulexu llima",
  "block.minecraft.pink_glazed_terracotta": "azulexu rosa",
  "block.minecraft.gray_glazed_terracotta": "azulexu buxu",
  "block.minecraft.light_gray_glazed_terracotta": "azulexu buxu claro",
  "block.minecraft.cyan_glazed_terracotta": "azulexu cianu",
  "block.minecraft.purple_glazed_terracotta": "azulexu moráu",
  "block.minecraft.blue_glazed_terracotta": "azulexu azul",
  "block.minecraft.brown_glazed_terracotta": "azulexu marrón",
  "block.minecraft.green_glazed_terracotta": "azulexu verde",
  "block.minecraft.red_glazed_terracotta": "azulexu coloráu",
  "block.minecraft.black_glazed_terracotta": "azulexu prietu",
  "block.minecraft.white_concrete": "formigón blanco",
  "block.minecraft.orange_concrete": "formigón naranxa",
  "block.minecraft.magenta_concrete": "formigón maxenta",
  "block.minecraft.light_blue_concrete": "formigón azul claro",
  "block.minecraft.yellow_concrete": "formigón mariello",
  "block.minecraft.lime_concrete": "formigón llima",
  "block.minecraft.pink_concrete": "formigón rosa",
  "block.minecraft.gray_concrete": "formigón buxo",
  "block.minecraft.light_gray_concrete": "formigón buxo claro",
  "block.minecraft.cyan_concrete": "formigón ciano",
  "block.minecraft.purple_concrete": "formigón morao",
  "block.minecraft.blue_concrete": "formigón azul",
  "block.minecraft.brown_concrete": "formigón marrón",
  "block.minecraft.green_concrete": "formigón verde",
  "block.minecraft.red_concrete": "formigón colorao",
  "block.minecraft.black_concrete": "formigón prieto",
  "block.minecraft.white_concrete_powder": "povisa de formigón blanco",
  "block.minecraft.orange_concrete_powder": "povisa de formigón naranxa",
  "block.minecraft.magenta_concrete_powder": "povisa de formigón maxenta",
  "block.minecraft.light_blue_concrete_powder": "povisa de formigón azul claro",
  "block.minecraft.yellow_concrete_powder": "povisa de formigón mariello",
  "block.minecraft.lime_concrete_powder": "povisa de formigón llima",
  "block.minecraft.pink_concrete_powder": "povisa de formigón rosa",
  "block.minecraft.gray_concrete_powder": "povisa de formigón buxo",
  "block.minecraft.light_gray_concrete_powder": "povisa de formigón buxo claro",
  "block.minecraft.cyan_concrete_powder": "povisa de formigón ciano",
  "block.minecraft.purple_concrete_powder": "povisa de formigón morao",
  "block.minecraft.blue_concrete_powder": "povisa de formigón azul",
  "block.minecraft.brown_concrete_powder": "povisa de formigón marrón",
  "block.minecraft.green_concrete_powder": "povisa de formigón verde",
  "block.minecraft.red_concrete_powder": "povisa de formigón colorao",
  "block.minecraft.black_concrete_powder": "povisa de formigón prieto",
  "block.minecraft.turtle_egg": "güevu de tortuga",
  "block.minecraft.dead_tube_coral_block": "bloque de coral de tubos muerto",
  "block.minecraft.dead_brain_coral_block": "bloque de coral de cerebru muerto",
  "block.minecraft.dead_bubble_coral_block": "bloque de coral de borboyos muerto",
  "block.minecraft.dead_fire_coral_block": "bloque de coral de fueu muerto",
  "block.minecraft.dead_horn_coral_block": "bloque de coral de cuernos muerto",
  "block.minecraft.tube_coral_block": "bloque de coral de tubos",
  "block.minecraft.brain_coral_block": "bloque de coral de cerebru",
  "block.minecraft.bubble_coral_block": "bloque de coral de borboyos",
  "block.minecraft.fire_coral_block": "bloque de coral de fueu",
  "block.minecraft.horn_coral_block": "bloque de coral de cuernos",
  "block.minecraft.tube_coral": "coral de tubos",
  "block.minecraft.brain_coral": "coral de cerebru",
  "block.minecraft.bubble_coral": "coral de borboyos",
  "block.minecraft.fire_coral": "coral de fueu",
  "block.minecraft.horn_coral": "coral de cuernos",
  "block.minecraft.dead_brain_coral": "coral de cerebru muerto",
  "block.minecraft.dead_bubble_coral": "coral de borboyos muerto",
  "block.minecraft.dead_fire_coral": "coral de fueu muerto",
  "block.minecraft.dead_horn_coral": "coral de cuernos muerto",
  "block.minecraft.dead_tube_coral": "coral de tubos muerto",
  "block.minecraft.tube_coral_fan": "gorgonia de tubos",
  "block.minecraft.brain_coral_fan": "gorgonia de cerebru",
  "block.minecraft.bubble_coral_fan": "gorgonia de borboyos",
  "block.minecraft.fire_coral_fan": "gorgonia de fueu",
  "block.minecraft.horn_coral_fan": "gorgonia de cuernos",
  "block.minecraft.dead_tube_coral_fan": "gorgonia de tubos muerto",
  "block.minecraft.dead_brain_coral_fan": "gorgonia de cerebru muerto",
  "block.minecraft.dead_bubble_coral_fan": "gorgonia de borboyos muerto",
  "block.minecraft.dead_fire_coral_fan": "gorgonia de fueu muerto",
  "block.minecraft.dead_horn_coral_fan": "gorgonia de cuernos muerto",
  "block.minecraft.blue_ice": "xelu",
  "block.minecraft.conduit": "canalizador",
  "block.minecraft.polished_granite_stairs": "pasales de granitu pulío",
  "block.minecraft.smooth_red_sandstone_stairs": "pasales de gres colorao dondo",
  "block.minecraft.mossy_stone_brick_stairs": "pasales de lladriyos de piedra mofosa",
  "block.minecraft.polished_diorite_stairs": "pasales de diorita pulío",
  "block.minecraft.mossy_cobblestone_stairs": "pasales de llastra mofoso",
  "block.minecraft.end_stone_brick_stairs": "pasales de lladriyos del end",
  "block.minecraft.stone_stairs": "pasales de piedra",
  "block.minecraft.smooth_sandstone_stairs": "pasales de gres dondo",
  "block.minecraft.smooth_quartz_stairs": "pasales de cuarzu dondo",
  "block.minecraft.granite_stairs": "pasales de granitu",
  "block.minecraft.andesite_stairs": "pasales d'andesita",
  "block.minecraft.red_nether_brick_stairs": "pasales de lladriyos coloraos del nether",
  "block.minecraft.polished_andesite_stairs": "pasales d'andesita pulío",
  "block.minecraft.diorite_stairs": "pasales de diorita",
  "block.minecraft.polished_granite_slab": "llábana de granitu pulío",
  "block.minecraft.smooth_red_sandstone_slab": "llábana de gres colorao dondo",
  "block.minecraft.mossy_stone_brick_slab": "llábana de lladriyos de piedra mofosa",
  "block.minecraft.polished_diorite_slab": "llábana de diorita pulío",
  "block.minecraft.mossy_cobblestone_slab": "llábana de llastra mofoso",
  "block.minecraft.end_stone_brick_slab": "llábana de lladriyos del end",
  "block.minecraft.smooth_sandstone_slab": "llábana de gres dondo",
  "block.minecraft.smooth_quartz_slab": "llábana de cuarzu dondo",
  "block.minecraft.granite_slab": "llábana de granitu",
  "block.minecraft.andesite_slab": "llábana d'andesita",
  "block.minecraft.red_nether_brick_slab": "llábana de lladriyos coloraos del nether",
  "block.minecraft.polished_andesite_slab": "llábana d'andesita pulío",
  "block.minecraft.diorite_slab": "llábana de diorita",
  "block.minecraft.scaffolding": "andamiu",
  "block.minecraft.iron_door": "puerta de fierro",
  "block.minecraft.oak_door": "puerta de carbayu",
  "block.minecraft.spruce_door": "puerta d'abetu",
  "block.minecraft.birch_door": "puerta de bidul",
  "block.minecraft.jungle_door": "puerta de madera de la xungla",
  "block.minecraft.acacia_door": "puerta d'alcacia",
  "block.minecraft.dark_oak_door": "puerta de carbayu escuru",
  "block.minecraft.crimson_door": "puerta carmesín",
  "block.minecraft.warped_door": "puerta distorsionada",
  "block.minecraft.repeater": "repitidor de redstone",
  "block.minecraft.comparator": "comparador de redstone",
  "block.minecraft.structure_block": "bloque d'estructures",
  "block.minecraft.jigsaw": "jigsaw block",
  "item.minecraft.turtle_helmet": "cascu de tortuga□□when on head:□+2 d'armadura",
  "item.minecraft.scute": "scute",
  "item.minecraft.iron_shovel": "pala de fierro□□when in main hand:□+3.5 de dañu d'ataque□-3 de velocidá d'ataque",
  "item.minecraft.iron_pickaxe": "picu de fierro□□when in main hand:□+3 de dañu d'ataque□-2.8 de velocidá d'ataque",
  "item.minecraft.iron_axe": "hachu de fierro□□when in main hand:□+8 de dañu d'ataque□-3.1 de velocidá d'ataque",
  "item.minecraft.flint_and_steel": "chisqueru",
  "item.minecraft.apple": "mazana",
  "item.minecraft.bow": "arcu",
  "item.minecraft.arrow": "flecha",
  "item.minecraft.coal": "carbón",
  "item.minecraft.charcoal": "carbón vexetal",
  "item.minecraft.diamond": "diamante",
  "item.minecraft.iron_ingot": "llingote de fierro",
  "item.minecraft.gold_ingot": "llingote d'oru",
  "item.minecraft.netherite_ingot": "llingote de netherita",
  "item.minecraft.netherite_scrap": "escoria de netherita",
  "item.minecraft.iron_sword": "espada de fierro□□when in main hand:□+5 de dañu d'ataque□-2.4 de velocidá d'ataque",
  "item.minecraft.wooden_sword": "espada de madera□□when in main hand:□+3 de dañu d'ataque□-2.4 de velocidá d'ataque",
  "item.minecraft.wooden_shovel": "pala de madera□□when in main hand:□+1.5 de dañu d'ataque□-3 de velocidá d'ataque",
  "item.minecraft.wooden_pickaxe": "picu de madera□□when in main hand:□+1 de dañu d'ataque□-2.8 de velocidá d'ataque",
  "item.minecraft.wooden_axe": "hachu de madera□□when in main hand:□+6 de dañu d'ataque□-3.2 de velocidá d'ataque",
  "item.minecraft.stone_sword": "espada de piedra□□when in main hand:□+4 de dañu d'ataque□-2.4 de velocidá d'ataque",
  "item.minecraft.stone_shovel": "pala de piedra□□when in main hand:□+2.5 de dañu d'ataque□-3 de velocidá d'ataque",
  "item.minecraft.stone_pickaxe": "picu de piedra□□when in main hand:□+2 de dañu d'ataque□-2.8 de velocidá d'ataque",
  "item.minecraft.stone_axe": "hachu de piedra□□when in main hand:□+8 de dañu d'ataque□-3.2 de velocidá d'ataque",
  "item.minecraft.diamond_sword": "espada de diamante□□when in main hand:□+6 de dañu d'ataque□-2.4 de velocidá d'ataque",
  "item.minecraft.diamond_shovel": "pala de diamante□□when in main hand:□+4.5 de dañu d'ataque□-3 de velocidá d'ataque",
  "item.minecraft.diamond_pickaxe": "picu de diamante□□when in main hand:□+4 de dañu d'ataque□-2.8 de velocidá d'ataque",
  "item.minecraft.diamond_axe": "hachu de diamante□□when in main hand:□+8 de dañu d'ataque□-3 de velocidá d'ataque",
  "item.minecraft.stick": "palu",
  "item.minecraft.bowl": "escudiella",
  "item.minecraft.mushroom_stew": "guisu de fungu",
  "item.minecraft.golden_sword": "espada d'oru□□when in main hand:□+3 de dañu d'ataque□-2.4 de velocidá d'ataque",
  "item.minecraft.golden_shovel": "pala d'oru□□when in main hand:□+1.5 de dañu d'ataque□-3 de velocidá d'ataque",
  "item.minecraft.golden_pickaxe": "picu d'oru□□when in main hand:□+1 de dañu d'ataque□-2.8 de velocidá d'ataque",
  "item.minecraft.golden_axe": "hachu d'oru□□when in main hand:□+6 de dañu d'ataque□-3 de velocidá d'ataque",
  "item.minecraft.netherite_sword": "espada de netherita□□when in main hand:□+7 de dañu d'ataque□-2.4 de velocidá d'ataque",
  "item.minecraft.netherite_shovel": "pala de netherita□□when in main hand:□+5.5 de dañu d'ataque□-3 de velocidá d'ataque",
  "item.minecraft.netherite_pickaxe": "picu de netherita□□when in main hand:□+5 de dañu d'ataque□-2.8 de velocidá d'ataque",
  "item.minecraft.netherite_axe": "hachu de netherita□□when in main hand:□+9 de dañu d'ataque□-3 de velocidá d'ataque",
  "item.minecraft.string": "filu",
  "item.minecraft.feather": "pluma",
  "item.minecraft.gunpowder": "pólvora",
  "item.minecraft.wooden_hoe": "fesoria de madera□□when in main hand:□-3 de velocidá d'ataque",
  "item.minecraft.stone_hoe": "fesoria de piedra□□when in main hand:□-2 de velocidá d'ataque",
  "item.minecraft.iron_hoe": "fesoria de fierro□□when in main hand:□-1 de velocidá d'ataque",
  "item.minecraft.diamond_hoe": "fesoria de diamante□□when in main hand:",
  "item.minecraft.golden_hoe": "fesoria d'oru□□when in main hand:□-3 de velocidá d'ataque",
  "item.minecraft.netherite_hoe": "fesoria de netherita□□when in main hand:",
  "item.minecraft.wheat_seeds": "semiente de trigu",
  "item.minecraft.wheat": "trigu",
  "item.minecraft.bread": "pan",
  "item.minecraft.leather_helmet": "cascu de cueru□□when on head:□+1 d'armadura",
  "item.minecraft.leather_chestplate": "túnica de cueru□□when on body:□+3 d'armadura",
  "item.minecraft.leather_leggings": "pantalones de cueru□□when on legs:□+2 d'armadura",
  "item.minecraft.leather_boots": "botes de cueru□□when on feet:□+1 d'armadura",
  "item.minecraft.chainmail_helmet": "cascu de cota malla□□when on head:□+2 d'armadura",
  "item.minecraft.chainmail_chestplate": "petu de cota malla□□when on body:□+5 d'armadura",
  "item.minecraft.chainmail_leggings": "pantalones de cota malla□□when on legs:□+4 d'armadura",
  "item.minecraft.chainmail_boots": "botes de cota malla□□when on feet:□+1 d'armadura",
  "item.minecraft.iron_helmet": "cascu de fierro□□when on head:□+2 d'armadura",
  "item.minecraft.iron_chestplate": "petu de fierro□□when on body:□+6 d'armadura",
  "item.minecraft.iron_leggings": "pantalones de fierro□□when on legs:□+5 d'armadura",
  "item.minecraft.iron_boots": "botes de fierro□□when on feet:□+2 d'armadura",
  "item.minecraft.diamond_helmet": "cascu de diamante□□when on head:□+3 d'armadura□+2 de durez d'armadura",
  "item.minecraft.diamond_chestplate": "petu de diamante□□when on body:□+8 d'armadura□+2 de durez d'armadura",
  "item.minecraft.diamond_leggings": "pantalones de diamante□□when on legs:□+6 d'armadura□+2 de durez d'armadura",
  "item.minecraft.diamond_boots": "botes de diamante□□when on feet:□+3 d'armadura□+2 de durez d'armadura",
  "item.minecraft.golden_helmet": "cascu d'oru□□when on head:□+2 d'armadura",
  "item.minecraft.golden_chestplate": "petu d'oru□□when on body:□+5 d'armadura",
  "item.minecraft.golden_leggings": "pantalones d'oru□□when on legs:□+3 d'armadura",
  "item.minecraft.golden_boots": "botes d'oru□□when on feet:□+1 d'armadura",
  "item.minecraft.netherite_helmet": "cascu de netherita□□when on head:□+3 d'armadura□+3 de durez d'armadura□+1 de resistencia al emburriu",
  "item.minecraft.netherite_chestplate": "petu de netherita□□when on body:□+8 d'armadura□+3 de durez d'armadura□+1 de resistencia al emburriu",
  "item.minecraft.netherite_leggings": "pantalones de netherita□□when on legs:□+6 d'armadura□+3 de durez d'armadura□+1 de resistencia al emburriu",
  "item.minecraft.netherite_boots": "botes de netherita□□when on feet:□+3 d'armadura□+3 de durez d'armadura□+1 de resistencia al emburriu",
  "item.minecraft.flint": "ferrial",
  "item.minecraft.porkchop": "chuleta de gochu cruda",
  "item.minecraft.cooked_porkchop": "chuleta de gochu cocinada",
  "item.minecraft.painting": "cuadru",
  "item.minecraft.golden_apple": "mazana d'oru",
  "item.minecraft.enchanted_golden_apple": "mazana d'oru encantexada",
  "block.minecraft.oak_sign": "cartelu de carbayu",
  "block.minecraft.spruce_sign": "cartelu d'abetu",
  "block.minecraft.birch_sign": "cartelu de bidul",
  "block.minecraft.jungle_sign": "cartelu de madera de la xungla",
  "block.minecraft.acacia_sign": "cartelu d'alcacia",
  "block.minecraft.dark_oak_sign": "cartelu de carbayu escuru",
  "block.minecraft.crimson_sign": "cartelu carmesín",
  "block.minecraft.warped_sign": "cartelu distorsionáu",
  "item.minecraft.bucket": "calderu",
  "item.minecraft.water_bucket": "calderu con agua",
  "item.minecraft.lava_bucket": "calderu con llava",
  "item.minecraft.minecart": "vagoneta",
  "item.minecraft.saddle": "sillín",
  "item.minecraft.redstone": "povisa de redstone",
  "item.minecraft.snowball": "pella",
  "item.minecraft.oak_boat": "barca de carbayu",
  "item.minecraft.leather": "cueru",
  "item.minecraft.milk_bucket": "calderu con lleche",
  "item.minecraft.pufferfish_bucket": "calderu con pexe globu",
  "item.minecraft.salmon_bucket": "calderu con salmón",
  "item.minecraft.cod_bucket": "calderu con bacalláu",
  "item.minecraft.tropical_fish_bucket": "calderu con pexe tropical",
  "item.minecraft.brick": "lladriyu",
  "item.minecraft.clay_ball": "bola de barru santo",
  "block.minecraft.dried_kelp_block": "bloque de laminarial seco",
  "item.minecraft.paper": "papel",
  "item.minecraft.book": "llibru",
  "item.minecraft.slime_ball": "bola de llimu",
  "item.minecraft.chest_minecart": "vagoneta con un bagul",
  "item.minecraft.furnace_minecart": "vagoneta con un fornu",
  "item.minecraft.egg": "güevu",
  "item.minecraft.compass": "brúxula",
  "item.minecraft.fishing_rod": "caña de pescar",
  "item.minecraft.clock": "reló",
  "item.minecraft.glowstone_dust": "povisa de piedra rellumante",
  "item.minecraft.cod": "bacalláu crudu",
  "item.minecraft.salmon": "salmón crudu",
  "item.minecraft.tropical_fish": "pexe tropical",
  "item.minecraft.pufferfish": "pexe globu",
  "item.minecraft.cooked_cod": "bacalláu cocináu",
  "item.minecraft.cooked_salmon": "salmón cocináu",
  "item.minecraft.ink_sac": "sacu de tinta",
  "item.minecraft.red_dye": "tiñe coloráu",
  "item.minecraft.green_dye": "tiñe verde",
  "item.minecraft.cocoa_beans": "fabes de cacáu",
  "item.minecraft.lapis_lazuli": "llapislázuli",
  "item.minecraft.purple_dye": "tiñe moráu",
  "item.minecraft.cyan_dye": "tiñe cianu",
  "item.minecraft.light_gray_dye": "tiñe buxu claro",
  "item.minecraft.gray_dye": "tiñe buxu",
  "item.minecraft.pink_dye": "tiñe rosa",
  "item.minecraft.lime_dye": "tiñe llima",
  "item.minecraft.yellow_dye": "tiñe mariellu",
  "item.minecraft.light_blue_dye": "tiñe azul claro",
  "item.minecraft.magenta_dye": "tiñe maxenta",
  "item.minecraft.orange_dye": "tiñe naranxa",
  "item.minecraft.bone_meal": "fariña óseo",
  "item.minecraft.blue_dye": "tiñe azul",
  "item.minecraft.brown_dye": "tiñe marrón",
  "item.minecraft.black_dye": "tiñe prietu",
  "item.minecraft.white_dye": "tiñe blancu",
  "item.minecraft.bone": "güesu",
  "item.minecraft.sugar": "azucre",
  "block.minecraft.cake": "tarta",
  "block.minecraft.white_bed": "cama blanca",
  "block.minecraft.orange_bed": "cama naranxa",
  "block.minecraft.magenta_bed": "cama maxenta",
  "block.minecraft.light_blue_bed": "cama azul claro",
  "block.minecraft.yellow_bed": "cama mariella",
  "block.minecraft.lime_bed": "cama llima",
  "block.minecraft.pink_bed": "cama rosa",
  "block.minecraft.gray_bed": "cama buxa",
  "block.minecraft.light_gray_bed": "cama buxa claro",
  "block.minecraft.cyan_bed": "cama ciana",
  "block.minecraft.purple_bed": "cama morada",
  "block.minecraft.blue_bed": "cama azul",
  "block.minecraft.brown_bed": "cama marrón",
  "block.minecraft.green_bed": "cama verde",
  "block.minecraft.red_bed": "cama colorada",
  "block.minecraft.black_bed": "cama prieta",
  "item.minecraft.cookie": "galleta",
  "item.minecraft.filled_map": "mapa□#0",
  "item.minecraft.shears": "tisoria",
  "item.minecraft.melon_slice": "cachu de sandía",
  "item.minecraft.dried_kelp": "laminarial seco",
  "item.minecraft.pumpkin_seeds": "semiente de calabaza",
  "item.minecraft.melon_seeds": "semiente de sandía",
  "item.minecraft.beef": "chuletón crudu",
  "item.minecraft.cooked_beef": "filete",
  "item.minecraft.chicken": "pita cruda",
  "item.minecraft.cooked_chicken": "pita cocinada",
  "item.minecraft.rotten_flesh": "carne apodrecío",
  "item.minecraft.ender_pearl": "perlla d'ender",
  "item.minecraft.blaze_rod": "vara d'espíritu llumiegu",
  "item.minecraft.ghast_tear": "llárima de ghast",
  "item.minecraft.gold_nugget": "llixu d'oru",
  "item.minecraft.nether_wart": "úzara del nether",
  "item.minecraft.potion": "brebaxe non ellaborable□ensin efeutos",
  "item.minecraft.glass_bottle": "frascu",
  "item.minecraft.spider_eye": "güeyu d'araña",
  "item.minecraft.fermented_spider_eye": "güeyu d'araña formentáu",
  "item.minecraft.blaze_powder": "povisa d'espíritu llumiegu",
  "item.minecraft.magma_cream": "crema magmática",
  "block.minecraft.brewing_stand": "destilador",
  "block.minecraft.cauldron": "caldera",
  "item.minecraft.ender_eye": "güeyu d'ender",
  "item.minecraft.glistering_melon_slice": "cachu de sandía rellumante",
  "item.minecraft.bat_spawn_egg": "güevu qu'apruz a un esperteyu",
  "item.minecraft.bee_spawn_egg": "güevu qu'apruz a una abeya",
  "item.minecraft.blaze_spawn_egg": "güevu qu'apruz a un espíritu llumiegu",
  "item.minecraft.cat_spawn_egg": "güevu qu'apruz a un gatu",
  "item.minecraft.cave_spider_spawn_egg": "güevu qu'apruz a una araña de cueva",
  "item.minecraft.chicken_spawn_egg": "güevu qu'apruz a una pita",
  "item.minecraft.cod_spawn_egg": "güevu qu'apruz a un bacalláu",
  "item.minecraft.cow_spawn_egg": "güevu qu'apruz a una vaca",
  "item.minecraft.creeper_spawn_egg": "güevu qu'apruz a un creeper",
  "item.minecraft.dolphin_spawn_egg": "güevu qu'apruz a una toliña",
  "item.minecraft.donkey_spawn_egg": "güevu qu'apruz a un pollín",
  "item.minecraft.drowned_spawn_egg": "güevu qu'apruz a un afogáu",
  "item.minecraft.elder_guardian_spawn_egg": "güevu qu'apruz a un guardián vieyu",
  "item.minecraft.enderman_spawn_egg": "güevu qu'apruz a un enderman",
  "item.minecraft.endermite_spawn_egg": "güevu qu'apruz a un endermite",
  "item.minecraft.evoker_spawn_egg": "güevu qu'apruz a un evocador",
  "item.minecraft.fox_spawn_egg": "güevu qu'apruz a un raposu",
  "item.minecraft.ghast_spawn_egg": "güevu qu'apruz a un ghast",
  "item.minecraft.guardian_spawn_egg": "güevu qu'apruz a un guardián",
  "item.minecraft.hoglin_spawn_egg": "güevu qu'apruz a un hoglin",
  "item.minecraft.horse_spawn_egg": "güevu qu'apruz a un caballu",
  "item.minecraft.husk_spawn_egg": "güevu qu'apruz a una momia",
  "item.minecraft.llama_spawn_egg": "güevu qu'apruz a una llama",
  "item.minecraft.magma_cube_spawn_egg": "güevu qu'apruz a un llimu magmáticu",
  "item.minecraft.mooshroom_spawn_egg": "güevu qu'apruz a un mooshroom",
  "item.minecraft.mule_spawn_egg": "güevu qu'apruz a una mula",
  "item.minecraft.ocelot_spawn_egg": "güevu qu'apruz a un ocelote",
  "item.minecraft.panda_spawn_egg": "güevu qu'apruz a un panda",
  "item.minecraft.parrot_spawn_egg": "güevu qu'apruz a un loru",
  "item.minecraft.phantom_spawn_egg": "güevu qu'apruz a un pantasma",
  "item.minecraft.pig_spawn_egg": "güevu qu'apruz a un gochu",
  "item.minecraft.piglin_spawn_egg": "güevu qu'apruz a un piglin",
  "item.minecraft.pillager_spawn_egg": "güevu qu'apruz a un saquiador",
  "item.minecraft.polar_bear_spawn_egg": "güevu qu'apruz a un osu polar",
  "item.minecraft.pufferfish_spawn_egg": "güevu qu'apruz a un pexe globu",
  "item.minecraft.rabbit_spawn_egg": "güevu qu'apruz a un coneyu",
  "item.minecraft.ravager_spawn_egg": "güevu qu'apruz a un afarador",
  "item.minecraft.salmon_spawn_egg": "güevu qu'apruz a un salmón",
  "item.minecraft.sheep_spawn_egg": "güevu qu'apruz a una oveya",
  "item.minecraft.shulker_spawn_egg": "güevu qu'apruz a un shulker",
  "item.minecraft.silverfish_spawn_egg": "güevu qu'apruz a una xibiella",
  "item.minecraft.skeleton_spawn_egg": "güevu qu'apruz a una cadarma",
  "item.minecraft.skeleton_horse_spawn_egg": "güevu qu'apruz a un caballu esqueléticu",
  "item.minecraft.slime_spawn_egg": "güevu qu'apruz a un llimu",
  "item.minecraft.spider_spawn_egg": "güevu qu'apruz a una araña",
  "item.minecraft.squid_spawn_egg": "güevu qu'apruz a un calamar",
  "item.minecraft.stray_spawn_egg": "güevu qu'apruz a un vagamundu",
  "item.minecraft.strider_spawn_egg": "strider spawn egg",
  "item.minecraft.trader_llama_spawn_egg": "güevu qu'apruz a una llama de viaxante",
  "item.minecraft.tropical_fish_spawn_egg": "güevu qu'apruz a un pexe tropical",
  "item.minecraft.turtle_spawn_egg": "güevu qu'apruz a una tortuga",
  "item.minecraft.vex_spawn_egg": "güevu qu'apruz a un picuscayu",
  "item.minecraft.villager_spawn_egg": "güevu qu'apruz a un aldeanu",
  "item.minecraft.vindicator_spawn_egg": "güevu qu'apruz a un vindicador",
  "item.minecraft.wandering_trader_spawn_egg": "güevu qu'apruz a un viaxante",
  "item.minecraft.witch_spawn_egg": "güevu qu'apruz a una bruxa",
  "item.minecraft.wither_skeleton_spawn_egg": "güevu qu'apruz a una cadarma de wither",
  "item.minecraft.wolf_spawn_egg": "güevu qu'apruz a un llobu",
  "item.minecraft.zoglin_spawn_egg": "güevu qu'apruz a un zoglin",
  "item.minecraft.zombie_spawn_egg": "güevu qu'apruz a un zombi",
  "item.minecraft.zombie_horse_spawn_egg": "güevu qu'apruz a un caballu zombi",
  "item.minecraft.zombie_villager_spawn_egg": "güevu qu'apruz a un aldeanu zombi",
  "item.minecraft.zombified_piglin_spawn_egg": "güevu qu'apruz a un piglin zombi",
  "item.minecraft.experience_bottle": "botella encantexada",
  "item.minecraft.fire_charge": "carga de fueu",
  "item.minecraft.writable_book": "llibru y pluma",
  "item.minecraft.written_book": "llibru escritu",
  "item.minecraft.emerald": "esmeralda",
  "item.minecraft.item_frame": "marcu d'oxetos",
  "block.minecraft.flower_pot": "tiestu",
  "item.minecraft.carrot": "cenahoria",
  "item.minecraft.potato": "pataca",
  "item.minecraft.baked_potato": "pataca enforniada",
  "item.minecraft.poisonous_potato": "pataca velenosa",
  "item.minecraft.map": "mapa baleru",
  "item.minecraft.golden_carrot": "cenahoria d'oru",
  "block.minecraft.skeleton_skull": "craniu de cadarma",
  "block.minecraft.wither_skeleton_skull": "craniu de wither",
  "block.minecraft.player_head": "tiesta de xugador",
  "block.minecraft.zombie_head": "tiesta de zombi",
  "block.minecraft.creeper_head": "tiesta de creeper",
  "block.minecraft.dragon_head": "tiesta de cuélebre",
  "item.minecraft.carrot_on_a_stick": "cenahoria nuna caña",
  "item.minecraft.warped_fungus_on_a_stick": "fungu distorsionáu nuna caña",
  "item.minecraft.nether_star": "estrella del nether",
  "item.minecraft.pumpkin_pie": "pastel de calabaza",
  "item.minecraft.firework_rocket": "volador",
  "item.minecraft.firework_star": "volador d'estrella",
  "item.minecraft.enchanted_book": "llibru encantexáu",
  "item.minecraft.nether_brick": "lladriyu del nether",
  "item.minecraft.quartz": "cuarzu del nether",
  "item.minecraft.tnt_minecart": "vagoneta con tnt",
  "item.minecraft.hopper_minecart": "vagoneta con embudu",
  "item.minecraft.prismarine_shard": "cachu de prismarín",
  "item.minecraft.prismarine_crystals": "cristales de prismarín",
  "item.minecraft.rabbit": "coneyu crudu",
  "item.minecraft.cooked_rabbit": "coneyu cocináu",
  "item.minecraft.rabbit_stew": "guisu de coneyu",
  "item.minecraft.rabbit_foot": "pie de coneyu",
  "item.minecraft.rabbit_hide": "pelleyu de coneyu",
  "item.minecraft.armor_stand": "maniquín",
  "item.minecraft.iron_horse_armor": "armadura caballuna de fierro",
  "item.minecraft.golden_horse_armor": "armadura caballuna d'oru",
  "item.minecraft.diamond_horse_armor": "armadura caballuna de diamante",
  "item.minecraft.leather_horse_armor": "leather horse armor",
  "item.minecraft.lead": "llaciu",
  "item.minecraft.name_tag": "etiqueta",
  "item.minecraft.command_block_minecart": "vagoneta con un bloque de comandos",
  "item.minecraft.mutton": "corderu crudu",
  "item.minecraft.cooked_mutton": "corderu cocináu",
  "block.minecraft.white_banner": "estandarte blancu",
  "block.minecraft.orange_banner": "estandarte naranxa",
  "block.minecraft.magenta_banner": "estandarte maxenta",
  "block.minecraft.light_blue_banner": "estandarte azul claru",
  "block.minecraft.yellow_banner": "estandarte mariellu",
  "block.minecraft.lime_banner": "estandarte llima",
  "block.minecraft.pink_banner": "estandarte rosa",
  "block.minecraft.gray_banner": "estandarte buxu",
  "block.minecraft.light_gray_banner": "estandarte buxu claru",
  "block.minecraft.cyan_banner": "estandarte cianu",
  "block.minecraft.purple_banner": "estandarte moráu",
  "block.minecraft.blue_banner": "estandarte azul",
  "block.minecraft.brown_banner": "estandarte marrón",
  "block.minecraft.green_banner": "estandarte verde",
  "block.minecraft.red_banner": "estandarte coloráu",
  "block.minecraft.black_banner": "estandarte prietu",
  "item.minecraft.end_crystal": "cristal del end",
  "item.minecraft.chorus_fruit": "fruta del coru",
  "item.minecraft.popped_chorus_fruit": "fruta del coru cocinada",
  "item.minecraft.beetroot": "remolacha",
  "item.minecraft.beetroot_seeds": "semiente de remolacha",
  "item.minecraft.beetroot_soup": "sopa de remolacha",
  "item.minecraft.dragon_breath": "frascu con aliendu de cuélebre",
  "item.minecraft.splash_potion": "brebaxe refundizu non ellaborable□ensin efeutos",
  "item.minecraft.spectral_arrow": "flecha espectral",
  "item.minecraft.tipped_arrow": "flecha non ellaborable□ensin efeutos",
  "item.minecraft.lingering_potion": "brebaxe prollongáu non ellaborable□ensin efeutos",
  "item.minecraft.shield": "escudu",
  "item.minecraft.elytra": "élitru",
  "item.minecraft.spruce_boat": "barca d'abetu",
  "item.minecraft.birch_boat": "barca de bidul",
  "item.minecraft.jungle_boat": "barca de madera de la xungla",
  "item.minecraft.acacia_boat": "barca d'alcacia",
  "item.minecraft.dark_oak_boat": "barca de carbayu escuru",
  "item.minecraft.totem_of_undying": "tótem d'inmortalidá",
  "item.minecraft.shulker_shell": "cascu de shulker",
  "item.minecraft.iron_nugget": "llixu de fierro",
  "item.minecraft.knowledge_book": "llibru de conocencia",
  "item.minecraft.debug_stick": "palu de depuración",
  "item.minecraft.music_disc_13": "vinilu□c418 - 13",
  "item.minecraft.music_disc_cat": "vinilu□c418 - cat",
  "item.minecraft.music_disc_blocks": "vinilu□c418 - blocks",
  "item.minecraft.music_disc_chirp": "vinilu□c418 - chirp",
  "item.minecraft.music_disc_far": "vinilu□c418 - far",
  "item.minecraft.music_disc_mall": "vinilu□c418 - mall",
  "item.minecraft.music_disc_mellohi": "vinilu□c418 - mellohi",
  "item.minecraft.music_disc_stal": "vinilu□c418 - stal",
  "item.minecraft.music_disc_strad": "vinilu□c418 - strad",
  "item.minecraft.music_disc_ward": "vinilu□c418 - ward",
  "item.minecraft.music_disc_11": "vinilu□c418 - 11",
  "item.minecraft.music_disc_wait": "vinilu□c418 - wait",
  "item.minecraft.music_disc_pigstep": "vinilu□lena raine - pigstep",
  "item.minecraft.trident": "tridente□□when in main hand:□+8 de dañu d'ataque□-2.9 de velocidá d'ataque",
  "item.minecraft.phantom_membrane": "membrana de pantasma",
  "item.minecraft.nautilus_shell": "cascu de nautilu",
  "item.minecraft.heart_of_the_sea": "corazón de la mar",
  "item.minecraft.crossbow": "ballesta",
  "item.minecraft.suspicious_stew": "guisu sospechosu",
  "block.minecraft.loom": "telar",
  "item.minecraft.flower_banner_pattern": "patrón d'estandarte□dibuxu de flor",
  "item.minecraft.creeper_banner_pattern": "patrón d'estandarte□dibuxu de creeper",
  "item.minecraft.skull_banner_pattern": "patrón d'estandarte□dibuxu de craniu",
  "item.minecraft.mojang_banner_pattern": "patrón d'estandarte□llogotipu",
  "item.minecraft.globe_banner_pattern": "patrón d'estandarte□planeta",
  "item.minecraft.piglin_banner_pattern": "patrón d'estandarte□focicu",
  "block.minecraft.composter": "compostador",
  "block.minecraft.barrel": "barril",
  "block.minecraft.smoker": "afumador",
  "block.minecraft.blast_furnace": "altu fornu",
  "block.minecraft.cartography_table": "mesa de cartografía",
  "block.minecraft.fletching_table": "mesa de fleches",
  "block.minecraft.grindstone": "piedra p'amolar",
  "block.minecraft.lectern": "atril",
  "block.minecraft.smithing_table": "mesa de ferrería",
  "block.minecraft.stonecutter": "cortapiedra",
  "block.minecraft.bell": "campana",
  "block.minecraft.lantern": "llámpara",
  "block.minecraft.soul_lantern": "llámpara d'ánimes",
  "item.minecraft.sweet_berries": "vagues dulces",
  "block.minecraft.campfire": "foguera",
  "block.minecraft.soul_campfire": "foguera d'ánimes",
  "block.minecraft.shroomlight": "shroomlight",
  "item.minecraft.honeycomb": "caxellar",
  "block.minecraft.bee_nest": "nial d'abeyes",
  "block.minecraft.beehive": "colmena",
  "item.minecraft.honey_bottle": "frascu con miel",
  "block.minecraft.honey_block": "bloque de miel",
  "block.minecraft.honeycomb_block": "bloque de caxellos",
  "block.minecraft.lodestone": "magnetita",
  "block.minecraft.netherite_block": "bloque de netherita",
  "block.minecraft.ancient_debris": "escombrios antiguos",
  "block.minecraft.target": "diana",
  "block.minecraft.crying_obsidian": "obsidiana lloroso",
  "block.minecraft.blackstone": "nigrilitu",
  "block.minecraft.blackstone_slab": "llábana de nigrilitu",
  "block.minecraft.blackstone_stairs": "pasales de nigrilitu",
  "block.minecraft.gilded_blackstone": "nigrilitu con oru",
  "block.minecraft.polished_blackstone": "nigrilitu pulío",
  "block.minecraft.polished_blackstone_slab": "llábana de nigrilitu pulío",
  "block.minecraft.polished_blackstone_stairs": "pasales de nigrilitu pulío",
  "block.minecraft.chiseled_polished_blackstone": "nigrilitu pulío y cincelao",
  "block.minecraft.polished_blackstone_bricks": "lladriyos de nigrilitu pulío",
  "block.minecraft.polished_blackstone_brick_slab": "llábana de lladriyos de nigrilitu pulío",
  "block.minecraft.polished_blackstone_brick_stairs": "pasales de lladriyos de nigrilitu pulío",
  "block.minecraft.cracked_polished_blackstone_bricks": "lladriyos frañaos de nigrilitu pulío",
  "block.minecraft.respawn_anchor": "bloque de remanecimientu",
}
export const ast_es = items; 
